import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>The code you entered is for an adult formula and the member is a young child.  For information on coding, refer to the Enteral Product Classification List found <a href="https://www.emedny.org/ProviderManuals/Pharmacy/PDFS/Enteral_Product_Classification_List-12-31-21.pdf">here</a>.</p>
				<p>For information on coding, refer to the Enteral Product Classification List available at www.emedny.org, click on ‘Provider Manuals’, then ‘DME’, then ‘Provider Communications’.</p>

				<div className="button" onClick={() => this.props.navigate('D8')}>Enter Another Code</div>
			</div>
		);
	}
}